import { CornerUpLeft } from 'lucide-react';

export default function RefundConversion() {
  return (
    <div className='w-6 h-6 rounded-full bg-zinc-900 flex items-center justify-center'>
      <CornerUpLeft size={14} className='text-zinc-400' />
    </div>
  );
}
